module.exports = __webpack_public_path__ + "static/media/coliseu_box_3.337efaa2.jpg";